import { api } from '../../src/config';

export const get_csrf_token = () => {
  return api({
    method: 'get',
    url: '/session/token?_format=json',
  });
};

export const get_logout_token = () => {
  return api({
    method: 'get',
    url: '/session/token/logout?_format=json',
    headers: {
      'Cache-Control': 'no-cache',
    },
  });
};

export const auth_login = (username, password, csrf_token) => {
  return api({
    method: 'post',
    url: '/user/login?_format=json',
    headers: {
      'X-CSRF-Token': csrf_token,
    },
    data: { name: username, pass: password },
  });
};

export const auth_logout = async () => {
  // Drupal 11: /user/logout has two routes on the same path — the browser route
  // (GET, confirm form) and the REST route user.logout.http (POST, _format=json).
  // Both now require a valid _csrf_token, so a stale/empty token yields 403
  // "'csrf_token' URL query argument is invalid." We therefore fetch a FRESH
  // logout_token (the CSRF token seeded for user.logout.http) and POST it
  // immediately within the same session — no React state, no stale closures.
  // Returns 204 on success.
  const { data } = await get_logout_token();
  return api({
    method: 'post',
    url: `/user/logout?_format=json&token=${data.logout_token}`,
    headers: {
      'Cache-Control': 'no-cache',
    },
  });
};